import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'servizio in camera',
      [RoomServiceLocationType.TableService]: 'servizio al tavolo',
    },
    [ORDER_METHODS.PICKUP]: 'ritiro',
    [ORDER_METHODS.DELIVERY]: 'consegna',
  },
  errors: {
    draft_validation_failed: "Completa l'indirizzo di consegna prima di continuare.",
  },
};
